// /**
//  * Brand Search in Mega Menu
//  * - 실시간 브랜드 검색 및 필터링
//  */
// class BrandSearch {
//   constructor() {
//     this.searchInput = document.querySelector('.brand-search-input');
//     this.brandList = document.querySelector('.mega-menu__list');
//     this.brandItems = null;
    
//     if (!this.searchInput || !this.brandList) return;
    
//     // 모든 브랜드 아이템 가져오기
//     this.brandItems = Array.from(this.brandList.querySelectorAll('.mega-menu__item'));
    
//     // 브랜드 데이터 매핑
//     this.brands = this.brandItems.map(item => {
//       const link = item.querySelector('.mega-menu__link--top');
//       return {
//         element: item,
//         name: link ? link.textContent.trim() : '',
//         url: link ? link.getAttribute('href') : '',
//         link: link
//       };
//     });
    
//     this.init();
//   }
  
//   init() {
//     // 입력 이벤트
//     this.searchInput.addEventListener('input', (e) => {
//       this.handleSearch(e.target.value);
//     });
    
//     // Enter 키로 첫 번째 결과 이동
//     this.searchInput.addEventListener('keydown', (e) => {
//       if (e.key === 'Enter') {
//         e.preventDefault();
//         this.goToFirstResult();
//       }
//     });
    
//     // 메가메뉴 열릴 때 검색 초기화
//     const brandMenu = this.searchInput.closest('details');
//     if (brandMenu) {
//       brandMenu.addEventListener('toggle', (e) => {
//         if (e.target.open) {
//           this.resetSearch();
//           this.searchInput.focus();
//         }
//       });
//     }
//   }
  
//   handleSearch(query) {
//     const searchTerm = query.toLowerCase().trim();
    
//     if (!searchTerm) {
//       this.resetSearch();
//       return;
//     }
    
//     this.brandList.classList.add('searching');
    
//     let visibleCount = 0;
    
//     // 각 브랜드 필터링
//     this.brands.forEach(brand => {
//       const matches = brand.name.toLowerCase().includes(searchTerm);
      
//       if (matches) {
//         brand.element.classList.add('visible');
//         brand.element.style.display = '';
        
//         // 매칭된 텍스트 강조
//         this.highlightMatch(brand.link, brand.name, searchTerm);
        
//         visibleCount++;
//       } else {
//         brand.element.classList.remove('visible');
//         brand.element.style.display = 'none';
//       }
//     });
    
//     // 결과 없음 메시지
//     this.showNoResultsMessage(visibleCount === 0, searchTerm);
//   }
  
//   highlightMatch(element, text, query) {
//     if (!element) return;
    
//     const regex = new RegExp(`(${this.escapeRegex(query)})`, 'gi');
//     const highlighted = text.replace(regex, '<mark class="brand-search-highlight">$1</mark>');
    
//     // 아이콘 유지
//     const icon = element.querySelector('.icon-caret-down');
//     const iconHTML = icon ? icon.outerHTML : '';
    
//     element.innerHTML = highlighted + iconHTML;
//   }
  
//   escapeRegex(string) {
//     return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
//   }
  
//   resetSearch() {
//     this.searchInput.value = '';
//     this.brandList.classList.remove('searching');
    
//     this.brands.forEach(brand => {
//       brand.element.classList.remove('visible');
//       brand.element.style.display = '';
      
//       // 원래 텍스트 복원
//       if (brand.link) {
//         const icon = brand.link.querySelector('.icon-caret-down');
//         const iconHTML = icon ? icon.outerHTML : '';
//         brand.link.innerHTML = brand.name + iconHTML;
//       }
//     });
    
//     this.hideNoResultsMessage();
//   }
  
//   goToFirstResult() {
//     const firstVisible = this.brands.find(brand => 
//       brand.element.classList.contains('visible') || 
//       brand.element.style.display !== 'none'
//     );
    
//     if (firstVisible && firstVisible.url) {
//       window.location.href = firstVisible.url;
//     }
//   }
  
//   showNoResultsMessage(show, query) {
//     let message = this.brandList.querySelector('.brand-search-no-results');
    
//     if (show) {
//       if (!message) {
//         message = document.createElement('div');
//         message.className = 'brand-search-no-results mega-menu__item';
//         this.brandList.appendChild(message);
//       }
//       message.textContent = `No brands found for "${query}"`;
//       message.style.display = 'block';
//     } else {
//       this.hideNoResultsMessage();
//     }
//   }
  
//   hideNoResultsMessage() {
//     const message = this.brandList.querySelector('.brand-search-no-results');
//     if (message) {
//       message.style.display = 'none';
//     }
//   }
// }

// // 초기화
// if (document.readyState === 'loading') {
//   document.addEventListener('DOMContentLoaded', () => {
//     new BrandSearch();
//   });
// } else {
//   new BrandSearch();
// }






/**
 * Brand Search in Mega Menu
 * - 실시간 브랜드 검색 및 필터링
 * - A-Z 알파벳 필터
 */
class BrandSearch {
  constructor() {
    this.searchInput = document.querySelector('.brand-search-input');
    this.brandList = document.querySelector('.brand-menu-list');
    this.alphabetBtns = document.querySelectorAll('.brand-alphabet-btn');
    this.brandItems = null;
    this.currentLetter = 'all';
    
    if (!this.searchInput || !this.brandList) return;
    
    // 모든 브랜드 아이템 가져오기
    this.brandItems = Array.from(this.brandList.querySelectorAll('.mega-menu__item'));
    
    // 브랜드 데이터 매핑
    this.brands = this.brandItems.map(item => {
      const link = item.querySelector('.mega-menu__link--top');
      const name = link ? link.textContent.trim() : '';
      return {
        element: item,
        name: name,
        firstLetter: name.charAt(0).toUpperCase(),
        url: link ? link.getAttribute('href') : '',
        link: link
      };
    });
    
    this.init();
    this.updateAlphabetButtons();
  }
  
  init() {
    // 검색 입력 이벤트
    this.searchInput.addEventListener('input', (e) => {
      this.currentLetter = 'all';
      this.updateActiveButton('all');
      this.handleSearch(e.target.value);
    });
    
    // Enter 키로 첫 번째 결과 이동
    this.searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.goToFirstResult();
      }
    });
    
    // 알파벳 버튼 클릭 이벤트
    this.alphabetBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const letter = e.target.dataset.letter;
        this.handleAlphabetFilter(letter);
      });
    });
    
    // 메가메뉴 열릴 때 초기화
    const brandMenu = this.searchInput.closest('details');
    if (brandMenu) {
      brandMenu.addEventListener('toggle', (e) => {
        if (e.target.open) {
          this.resetSearch();
          setTimeout(() => this.searchInput.focus(), 100);
        }
      });
    }
  }
  
  handleAlphabetFilter(letter) {
    this.currentLetter = letter;
    this.searchInput.value = '';
    this.updateActiveButton(letter);
    
    if (letter === 'all') {
      this.showAllBrands();
      return;
    }
    
    this.brandList.classList.add('searching');
    let visibleCount = 0;
    
    this.brands.forEach(brand => {
      const matches = brand.firstLetter === letter;
      
      if (matches) {
        brand.element.classList.add('visible');
        brand.element.style.display = '';
        visibleCount++;
      } else {
        brand.element.classList.remove('visible');
        brand.element.style.display = 'none';
      }
      
      // 하이라이트 제거
      if (brand.link) {
        const icon = brand.link.querySelector('.icon-caret-down');
        const iconHTML = icon ? icon.outerHTML : '';
        brand.link.innerHTML = brand.name + iconHTML;
      }
    });
    
    this.showNoResultsMessage(visibleCount === 0, `brands starting with "${letter}"`);
  }
  
  handleSearch(query) {
    const searchTerm = query.toLowerCase().trim();
    
    if (!searchTerm) {
      if (this.currentLetter !== 'all') {
        this.handleAlphabetFilter(this.currentLetter);
      } else {
        this.resetSearch();
      }
      return;
    }
    
    this.brandList.classList.add('searching');
    let visibleCount = 0;
    
    // 검색 + 알파벳 필터 조합
    this.brands.forEach(brand => {
      let matches = brand.name.toLowerCase().includes(searchTerm);
      
      // 알파벳 필터가 활성화되어 있으면 추가 필터링
      if (this.currentLetter !== 'all' && matches) {
        matches = brand.firstLetter === this.currentLetter;
      }
      
      if (matches) {
        brand.element.classList.add('visible');
        brand.element.style.display = '';
        this.highlightMatch(brand.link, brand.name, searchTerm);
        visibleCount++;
      } else {
        brand.element.classList.remove('visible');
        brand.element.style.display = 'none';
      }
    });
    
    this.showNoResultsMessage(visibleCount === 0, searchTerm);
  }
  
  showAllBrands() {
    this.brandList.classList.remove('searching');
    
    this.brands.forEach(brand => {
      brand.element.classList.remove('visible');
      brand.element.style.display = '';
      
      // 원래 텍스트 복원
      if (brand.link) {
        const icon = brand.link.querySelector('.icon-caret-down');
        const iconHTML = icon ? icon.outerHTML : '';
        brand.link.innerHTML = brand.name + iconHTML;
      }
    });
    
    this.hideNoResultsMessage();
  }
  
  updateActiveButton(letter) {
    this.alphabetBtns.forEach(btn => {
      if (btn.dataset.letter === letter) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }
  
  updateAlphabetButtons() {
    // 브랜드가 있는 알파벳만 활성화
    const availableLetters = new Set(this.brands.map(b => b.firstLetter));
    
    this.alphabetBtns.forEach(btn => {
      const letter = btn.dataset.letter;
      if (letter !== 'all' && !availableLetters.has(letter)) {
        btn.disabled = true;
      }
    });
  }
  
  highlightMatch(element, text, query) {
    if (!element) return;
    
    const regex = new RegExp(`(${this.escapeRegex(query)})`, 'gi');
    const highlighted = text.replace(regex, '<mark class="brand-search-highlight">$1</mark>');
    
    const icon = element.querySelector('.icon-caret-down');
    const iconHTML = icon ? icon.outerHTML : '';
    
    element.innerHTML = highlighted + iconHTML;
  }
  
  escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  
  resetSearch() {
    this.searchInput.value = '';
    this.currentLetter = 'all';
    this.updateActiveButton('all');
    this.showAllBrands();
  }
  
  goToFirstResult() {
    const firstVisible = this.brands.find(brand => 
      brand.element.style.display !== 'none'
    );
    
    if (firstVisible && firstVisible.url) {
      window.location.href = firstVisible.url;
    }
  }
  
  showNoResultsMessage(show, query) {
    let message = this.brandList.querySelector('.brand-search-no-results');
    
    if (show) {
      if (!message) {
        message = document.createElement('div');
        message.className = 'brand-search-no-results mega-menu__item';
        this.brandList.appendChild(message);
      }
      message.textContent = `No brands found for "${query}"`;
      message.style.display = 'block';
    } else {
      this.hideNoResultsMessage();
    }
  }
  
  hideNoResultsMessage() {
    const message = this.brandList.querySelector('.brand-search-no-results');
    if (message) {
      message.style.display = 'none';
    }
  }
}

// 초기화
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BrandSearch();
  });
} else {
  new BrandSearch();
}